import {fetchCookies} from "../../user/api/fetch_cookies";
import {IReservationError, ReservationErrorKind, ReservationPhase} from "../types/IReservationError";
import {toReservationError} from "./normalize_reservation_error";

// csrf - the first mutation of a session without the CSRF cookie; forbidden - an unrecognised 403, e.g. a page from the ingress
const AUTH_RETRY_KINDS: ReservationErrorKind[] = ["csrf", "forbidden"];
const MAX_AUTH_RETRIES = 1;

export type ReservationApiResult<T> = {data: T; error?: never} | {data?: never; error: IReservationError};

export interface ICallWithCsrfRetryParams<T> {
    call: () => Promise<T>;
    phase: ReservationPhase;
    // shared by the calls that may repeat one CSRF failure between them, e.g. every call of one run of the flow
    budget: {authRetriesUsed: number};
    // false once the result is no longer wanted - a failure is then neither repeated nor followed by a cookie refresh
    isCurrent: () => boolean;
}

// Settles a reservation call as its data or a normalized error, repeating it once after a CSRF failure
export const callWithCsrfRetry = async <T>(params: ICallWithCsrfRetryParams<T>): Promise<ReservationApiResult<T>> => {
    const {call, phase, budget, isCurrent} = params;

    try {
        return {data: await call()};
    } catch (error) {
        const reservationError = toReservationError(error, phase);

        if (!AUTH_RETRY_KINDS.includes(reservationError.kind) || budget.authRetriesUsed >= MAX_AUTH_RETRIES || !isCurrent()) {
            return {error: reservationError};
        }

        budget.authRetriesUsed += 1;
        // usually the CSRF cookie is missing - the cookies endpoint sets it again before the same call is repeated
        await fetchCookies();

        return isCurrent() ? callWithCsrfRetry(params) : {error: reservationError};
    }
};
import {fetchCookies} from "../../user/api/fetch_cookies";
import {IReservationError, ReservationErrorKind, ReservationPhase} from "../types/IReservationError";
import {toReservationError} from "./normalize_reservation_error";

// csrf - the first mutation of a session without the CSRF cookie; forbidden - an unrecognised 403, e.g. a page from the ingress
const AUTH_RETRY_KINDS: ReservationErrorKind[] = ["csrf", "forbidden"];
const MAX_AUTH_RETRIES = 1;

export type ReservationApiResult<T> = {data: T; error?: never} | {data?: never; error: IReservationError};

export interface ICallWithCsrfRetryParams<T> {
    call: () => Promise<T>;
    phase: ReservationPhase;
    // shared by the calls that may repeat one CSRF failure between them, e.g. every call of one run of the flow
    budget: {authRetriesUsed: number};
    // false once the result is no longer wanted - a failure is then neither repeated nor followed by a cookie refresh
    isCurrent: () => boolean;
}

// Settles a reservation call as its data or a normalized error, repeating it once after a CSRF failure
export const callWithCsrfRetry = async <T>(params: ICallWithCsrfRetryParams<T>): Promise<ReservationApiResult<T>> => {
    const {call, phase, budget, isCurrent} = params;

    try {
        return {data: await call()};
    } catch (error) {
        const reservationError = toReservationError(error, phase);

        if (!AUTH_RETRY_KINDS.includes(reservationError.kind) || budget.authRetriesUsed >= MAX_AUTH_RETRIES || !isCurrent()) {
            return {error: reservationError};
        }

        budget.authRetriesUsed += 1;
        // usually the CSRF cookie is missing - the cookies endpoint sets it again before the same call is repeated
        await fetchCookies();

        return isCurrent() ? callWithCsrfRetry(params) : {error: reservationError};
    }
};
